﻿<div [class.hidden]="!enabled" class="rdo-overlay">
  <img id="overlayImage" #overlayImage src="/assets/images/loader-sm.gif" [ngClass]="imgClass" width="20" height="20" />
</div>
